import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const zohoCrm = defineConnector({
  identifier: "zohoCrm",
  name: "Zoho CRM",
  tagLine: "Customer relationship management",
  keywords:
    "customer relationship management leads deals contacts accounts zohoapis",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () =>
    "https://www\\.zohoapis\\.(com|eu|in|com\\.cn|com\\.au|jp)/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.accessToken,
        scheme: "Zoho-oauthtoken",
      },
    ]),
  steps: [
    {
      title: "Select your Zoho data center",
      items: [
        {
          kind: "select",
          label: "Data center",
          required: true,
          target: { kind: "configuration", field: "datacenter" },
          options: [
            { value: "com", label: "United States (zohoapis.com)" },
            { value: "eu", label: "Europe (zohoapis.eu)" },
            { value: "in", label: "India (zohoapis.in)" },
            { value: "com.cn", label: "China (zohoapis.com.cn)" },
            { value: "com.au", label: "Australia (zohoapis.com.au)" },
            { value: "jp", label: "Japan (zohoapis.jp)" },
          ],
          defaultValue: "com",
          helperText:
            "Select the data center where your Zoho account is hosted.",
        },
      ],
    },
    {
      title: "Get your Zoho CRM access token",
      items: [
        {
          kind: "markdown",
          content:
            "Generate an access token from the Zoho API Console at **api-console.zoho.com**. Create a Self Client and generate a token with the required scopes.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ datacenter }) =>
      `https://www.zohoapis.${datacenter}/crm/v2/users?type=CurrentUser`,
  },
  publicEnvVars: ({ datacenter }) => ({
    ZOHO_CRM_DATACENTER: datacenter || "",
  }),
});
